import React from "react";
import { CircleHelp } from 'lucide-react';
import { NotificationDropdown } from "./NotificationDropdown";
import { useAuth } from "../AuthProvider";
import { Navigate } from "react-router-dom";

export const Header = ({ title }) => {
  const { currentUser } = useAuth();
  const handleProfile = () => {
    Navigate('/recentActivities');
  };

  return (
    <header className="bg-white border-b border-[1px] border-[#F6F6F6]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <h1 className="hidden md:block text-xl md:text-xl font-medium bg-[#121212] text-transparent bg-clip-text">
            {title}
          </h1>
          
          <div className="flex items-center gap-2 ml-auto">
            {/* <a href="/help" className="hidden sm:block">
              <button 
                className="p-2 cursor-pointer rounded-full text-indigo-600 hover:text-indigo-800 hover:bg-indigo-50 transition-all duration-200"
                aria-label="Help"
              >
                <CircleHelp className="h-5 w-5" />
              </button>
            </a> */}
            
            {/* <NotificationDropdown /> */}
            {currentUser && (
              <div className="flex items-center">
                <button onClick={handleProfile} className="focus:outline-none">
                  <div className="h-8 w-8 rounded-full bg-black flex items-center justify-center text-white font-medium">
                    {currentUser.displayName ? currentUser.displayName.charAt(0).toUpperCase() : 'U'}
                  </div>
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};